import * as Sentry from '@sentry/react';

const isLocalhost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !isLocalhost && Boolean(import.meta.env.VITE_SENTRY_DSN),

  sendDefaultPii: true,

  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^\//, /^https:\/\/api(-dev)?\.campdesk\.pl\/api/],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  enableLogs: true,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
  ],
});
